import { Component, OnInit } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { Invoicetrackreq } from 'src/app/model/invoicetrackreq.model';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
//import { User } from 'src/app/model/user.model';
//import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-invoicetrackreq',
  templateUrl: './invoicetrackreq.component.html',
  styleUrls: ['./invoicetrackreq.component.css']
})
export class InvoicetrackreqComponent implements OnInit {

  //user : User;
  constructor(private invoiceService : InvoiceService) { }

  ngOnInit() {
    // this.userServices.currentUser.subscribe(
    //   (data :any) => {
    //     this.user = data;
    //     console.log(this.user);
    //   }
    // )
  }
  

  
  SubmitInvoiceForm(form: NgForm){

    console.log(form.value);

    this.invoiceService.saveInvoice(form.value).subscribe(
      (data : any) => {
        console.log(data);
      }
    )


    

  }

}
